import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doGetCampus, doUpdateCampus } from '../../../store/campus.slice';
import { doGetCampusData } from '../../../store/campusData.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/business/campus/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../lib/barVariant';

interface IMatch {
  id: string;
}

const BusinessCampusEdit: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { campus, isLoading } = useSelector((state: RootState) => state.campus);

  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);

  useEffect(() => {
    getCampus();
  }, []);

  const getCampus = async () => {
    const res = await dispatch(doGetCampus(id));
    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: any) => {
    const res = await dispatch(doUpdateCampus(id, req));

    switch (res?.status) {
      case 200:
        dispatch(doGetCampusData());
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.push(`/business/campus${location.search}`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.business')}
        currentMenu={t('business.campus.title5')}
      />
      <Editor
        campus={campus || null}
        onSubmit={onSubmit}
      />
      <Footer />
    </div>
  )
}

export default BusinessCampusEdit;
